import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

export function getItavMaterialList(params) {
  return request({
    url: `${v2Host}/res_store/list`,
    method: 'get',
    params: cookRequestParams(params)
  })
}

export function getNonItavMaterialList(params) {
  return request({
    url: `${v2Host}/res_store/list2`,
    method: 'get',
    params: cookRequestParams(params)
  })
}
